import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AESEncryptionService } from './aesencryption.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  baseUrl: any = {};
  dev: any = {
    pincodeCityService: 'https://dev-api.bajajcapital.com/bclcomapp/api/pincodemaster',
    createVisitorURL: 'https://dev-api.bajajcapital.com/bclcomapp/api/create_visitor',
    createLeadURL: 'https://dev-api.bajajcapital.com/bclcomapp/api/create_lead',
    sendOtpURL: 'https://dev-api.bajajcapital.com/bclcomapp/api/send_otp',
    verifyOtpURL: 'https://dev-api.bajajcapital.com/bclcomapp/api/verify_otp',
    LSQLeadPush: 'https://dev-api.bajajcapital.com/bclcomapp/api/lsqLeadpushRetirement',
    seoServiceUrl: 'https://dev-cms.bajajcapitalone.com/services/api/bajaj-seo?_format=json',
    commonServiceUrl: 'https://dev-cms.bajajcapitalone.com/services/API/common-header-footer?format=json',
    serviceUrl: 'https://dev-cms.bajajcapitalone.com/services/api/homepage?format=json',
    searchUrl: 'https://dev-cms.bajajcapitalone.com/services/api/search/',
    retirementWebinarHomepageNew: 'https://dev-cms.bajajcapitalone.com/services/api/bajaj-nps-webinar-homepage',
    retirementWebinarSpeakersNew: 'https://dev-cms.bajajcapitalone.com/services/api/retirement-webinar-speakers-new',
    getRetirementWebinars: 'https://dev-cms.bajajcapitalone.com/services/api/bajaj-nps-webinar?format=json&date_time_val=',
    webinarLeadsNew: 'https://dev-api.bajajcapital.com/bclcomapp/api/createWebinarLeadsNew',
    LSQLeadPushWebinar: 'https://dev-api.bajajcapital.com/bclcomapp/api/lsqPushLeadNpsWebinar',
    retirementUpcomingWebinarNew: 'https://dev-cms.bajajcapitalone.com/services/api/retirement-webinar-new?format=json&date_time_val=',
    cityService: 'https://dev-api.bajajcapital.com/bclcomapp/api/city_master',
    campaignleads: 'https://dev-api.bajajcapital.com/bclcomapp/api/insertCampaignlead',
    campaignleadsupdate: 'https://dev-api.bajajcapital.com/bclcomapp/api/updateCampaignlead',
    updateslot: "https://dev-api.bajajcapital.com/bclcomapp/api/lsqUpdateDateSlot",

    webengageEncrypt:'https://dev-api.bajajcapital.com/bclcomapp/api/encryptData',
    salesForceBridge:'https://dev-api.bajajcapital.com/bclcomapp/api/sfLeadpush',
    updateCasLead: 'https://dev-api.bajajcapital.com/bclcomapp/api/updateCasLead',

  };

  stage: any = {
    pincodeCityService: 'https://stage-api.bajajcapital.com/bclcomapp/api/pincodemaster',
    createVisitorURL: 'https://stage-api.bajajcapital.com/bclcomapp/api/create_visitor',
    createLeadURL: 'https://stage-api.bajajcapital.com/bclcomapp/api/create_lead',
    sendOtpURL: 'https://stage-api.bajajcapital.com/bclcomapp/api/send_otp',
    verifyOtpURL: 'https://stage-api.bajajcapital.com/bclcomapp/api/verify_otp',
    LSQLeadPush: 'https://stage-api.bajajcapital.com/bclcomapp/api/lsqLeadpushRetirement',
    seoServiceUrl: 'https://stage-cms.bajajcapitalone.com/services/api/bajaj-seo?_format=json',
    commonServiceUrl: 'https://stage-cms.bajajcapitalone.com/services/API/common-header-footer?format=json',
    serviceUrl: 'https://stage-cms.bajajcapitalone.com/services/api/homepage?format=json',
    searchUrl: 'https://stage-cms.bajajcapitalone.com/services/api/search/',
    retirementWebinarHomepageNew: 'https://stage-cms.bajajcapitalone.com/services/api/bajaj-nps-webinar-homepage',
    retirementWebinarSpeakersNew: 'https://stage-cms.bajajcapitalone.com/services/api/retirement-webinar-speakers-new',
    getRetirementWebinars: 'https://stage-cms.bajajcapitalone.com/services/api/bajaj-nps-webinar?format=json&date_time_val=',
    webinarLeadsNew: 'https://dev-api.bajajcapital.com/bclcomapp/api/createWebinarLeadsNew',
    LSQLeadPushWebinar: 'https://stage-api.bajajcapital.com/bclcomapp/api/lsqPushLeadNpsWebinar',
    retirementUpcomingWebinarNew: 'https://stage-cms.bajajcapitalone.com/services/api/retirement-webinar-new?format=json&date_time_val=',
    cityService: 'https://stage-api.bajajcapital.com/bclcomapp/api/city_master',
    campaignleads: 'https://stage-api.bajajcapital.com/bclcomapp/api/insertCampaignlead',
    campaignleadsupdate: 'https://stage-api.bajajcapital.com/bclcomapp/api/updateCampaignlead',
    updateslot: "https://stage-api.bajajcapital.com/bclcomapp/api/lsqUpdateDateSlot",

    webengageEncrypt:'https://stage-api.bajajcapital.com/bclcomapp/api/encryptData',
    salesForceBridge:'https://stage-api.bajajcapital.com/bclcomapp/api/sfLeadpush',
    updateCasLead: 'https://stage-api.bajajcapital.com/bclcomapp/api/updateCasLead',


  };

  prod: any = {
    pincodeCityService: 'https://prod-api.bajajcapital.com/bclcomapp/api/pincodemaster',
    createVisitorURL: 'https://prod-api.bajajcapital.com/bclcomapp/api/create_visitor',
    createLeadURL: 'https://prod-api.bajajcapital.com/bclcomapp/api/create_lead',
    sendOtpURL: 'https://prod-api.bajajcapital.com/bclcomapp/api/send_otp',
    verifyOtpURL: 'https://prod-api.bajajcapital.com/bclcomapp/api/verify_otp',
    LSQLeadPush: 'https://prod-api.bajajcapital.com/bclcomapp/api/lsqLeadpushRetirement',
    seoServiceUrl: 'https://cms.bajajcapitalone.com/services/api/bajaj-seo?_format=json',
    commonServiceUrl: 'https://cms.bajajcapitalone.com/services/API/common-header-footer?format=json',
    serviceUrl: 'https://cms.bajajcapitalone.com/services/api/homepage?format=json',
    searchUrl: 'https://cms.bajajcapitalone.com/services/api/search/',
    retirementWebinarHomepageNew: 'https://cms.bajajcapitalone.com/services/api/bajaj-nps-webinar-homepage',
    retirementWebinarSpeakersNew: 'https://cms.bajajcapitalone.com/services/api/retirement-webinar-speakers-new',
    getRetirementWebinars: 'https://cms.bajajcapitalone.com/services/api/bajaj-nps-webinar?format=json&date_time_val=',
    webinarLeadsNew: 'https://prod-api.bajajcapital.com/bclcomapp/api/createWebinarLeadsNew',
    LSQLeadPushWebinar: 'https://prod-api.bajajcapital.com/bclcomapp/api/lsqPushLeadNpsWebinar',
    retirementUpcomingWebinarNew: 'https://cms.bajajcapitalone.com/services/api/retirement-webinar-new?format=json&date_time_val=',
    cityService: 'https://prod-api.bajajcapital.com/bclcomapp/api/city_master',
    campaignleads: 'https://prod-api.bajajcapital.com/bclcomapp/api/insertCampaignlead',
    campaignleadsupdate: 'https://prod-api.bajajcapital.com/bclcomapp/api/updateCampaignlead',
    updateslot: "https://prod-api.bajajcapital.com/bclcomapp/api/lsqUpdateDateSlot",

    webengageEncrypt:'https://prod-api.bajajcapital.com/bclcomapp/api/encryptData',
    salesForceBridge:'https://prod-api.bajajcapital.com/bclcomapp/api/sfLeadpush',
    updateCasLead: 'https://prod-api.bajajcapital.com/bclcomapp/api/updateCasLead',

  };
  constructor(
    private http: HttpClient,
    private _encryptionService: AESEncryptionService
  ) {
    let env = environment.envName;
    // let env = 'prod';
    if (env.toLowerCase() === 'dev') {
      this.baseUrl = this.dev;
    } else if (env.toLowerCase() === 'stage') {
      this.baseUrl = this.stage;
    } else if (env.toLowerCase() === 'prod') {
      this.baseUrl = this.prod;
    }
  }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  cityFiler(pincode: string) {
    return this.http.get(
      this.baseUrl['pincodeCityService'] + '?pincode=' + pincode,
      this.httpOptions
    );
  }

  getDynamicMeta() {
    return this.http.get(this.baseUrl['seoServiceUrl'], this.httpOptions);
  }

  createVisitor(obj: any) {
    // console.log('visitor',obj);
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    return this.http.post(this.baseUrl['createVisitorURL'], data);
  }

  createLead(obj: any) {
    // console.log('create service lead', obj);
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    return this.http.post(this.baseUrl['createLeadURL'], data);
  }
  sendOtp(obj: any) {
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    return this.http.post(this.baseUrl['sendOtpURL'], data);
  }

  verifyOtp(obj: any) {
    var randomNumber = Math.floor(Math.random() * 90000000) + 10000000;
    obj.randomNum = randomNumber;

    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    return this.http.post(this.baseUrl['verifyOtpURL'], data).pipe(
      map((response: any) => {
        let decryptedData = this._encryptionService.decrypt(response);

        if (decryptedData.success && decryptedData.randomNum != randomNumber) {
          decryptedData.success = false;
          decryptedData.message = 'invalid';
          return decryptedData;
        }
        return decryptedData;
      })
    );
  }

  pushLeadToLSQ(obj: any) {
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    // return this.http.post("http://localhost:8087/bclcomapp/api/lsqLeadpushRetirement",obj);
    return this.http.post(this.baseUrl['LSQLeadPush'], data);
  }


  getCommonSection() {
    //header menu,hamburgur menu, footer munu links
    let data = this.http.get(this.baseUrl["commonServiceUrl"], this.httpOptions);
    return data;
  }

  getData(){
    return this.http.get(this.baseUrl['serviceUrl'], this.httpOptions);
  }

  search(term: string): Observable<any[]> {
    let data = this.http.get<any[]>(this.baseUrl["searchUrl"] + '?format=json&keyword=' + term, this.httpOptions);
    return data;
  }

  // -NPS webinar 
  getRetirementWebinarHomepageNew() {
    return this.http.get(
      this.baseUrl['retirementWebinarHomepageNew'],
      this.httpOptions
    );
  }

  getRetirementWebinarSpeakersNew() {
    return this.http.get(
      this.baseUrl['retirementWebinarSpeakersNew'],
      this.httpOptions
    );
  }

  getRetirementWebinars(dateTime: any) {
    return this.http.get(
      this.baseUrl['getRetirementWebinars'] + dateTime,
      this.httpOptions
    );
  }

  webinarLeadsNew(obj: any) {
    // return this.http.post('http://localhost:8087/bclcomapp/api/createwebinarLeadsNew', obj);
    return this.http.post(this.baseUrl['webinarLeadsNew'], obj);
  }


  pushLeadToLSQWebinar(obj: any) {
    // return this.http.post("http://localhost:8087/bclcomapp/api/lsqPushLeadNpsWebinar",obj);
    return this.http.post(this.baseUrl['LSQLeadPushWebinar'], obj);
  }

  // getUpcomingWebinarSpeakerNew(dateTime: any) {
  //   return this.http.get(
  //     this.baseUrl['retirementUpcomingWebinarNew'] + dateTime,
  //     this.httpOptions
  //   );
  // }

  cityDropDown() {
    return this.http.get(this.baseUrl['cityService'], this.httpOptions);
  }


  campaignlead(obj: any) {
    return this.http.post(this.baseUrl['campaignleads'], obj);
  }


  campaignleadupdate(obj: any) {
    return this.http.post(this.baseUrl['campaignleadsupdate'], obj);
  }

  updateSlotTime(obj: any) {
    return this.http.post(this.baseUrl['updateslot'], obj);
  }


  webengageEncrypt(obj: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('key', environment.webEncryptKey);
    headers = headers.append('secret', environment.webEncryptSecret);
    return this.http.post(this.baseUrl['webengageEncrypt'], obj, {
      headers: headers,
    });
  }

  pushLeadToSF(obj:any) {
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    // return this.http.post("http://localhost:8087/bclcomapp/api/sfLeadpush",data);
    return this.http.post(this.baseUrl['salesForceBridge'], data);
  }

  updateCasLead(obj: any) {
    let encryptedText = this._encryptionService.encrypt(obj);
    let data = { data: encryptedText };
    // return this.http.post("http://localhost:8087/bclcomapp/api/updateCasLead",data);
    return this.http.post(this.baseUrl['updateCasLead'], data);
  }


}
